import { takeLatest, put, call } from 'redux-saga/effects'

import { deleteBot, fetchBots } from './helpers/bots'

import { DELETE_BOT, FETCH_BOTS, fetchBotsSuccess } from 'Actions/bots'

export default function* appSaga() {
  yield takeLatest(FETCH_BOTS, onFetchBots)
  yield takeLatest(DELETE_BOT, onDeleteBot)
}

const onFetchBots = function* () {
  try {
    const bots = yield call(fetchBots)
    yield put(fetchBotsSuccess(bots))
  } catch (err) {
    console.error('Unable to fetch bots', err)
  }
}

const onDeleteBot = function* (action) {
  const { botId } = action.payload
  yield call(deleteBot, botId)
}
